import { render, staticRenderFns } from "./TagRemove.vue?vue&type=template&id=59bed07f"
import script from "./TagRemove.vue?vue&type=script&lang=js"
export * from "./TagRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports